import type { AgeLabels } from './age-labels.type';

export function formatChildAge(dateOfBirth: string, labels: AgeLabels, now: Date = new Date()): string {
  const dob: Date = new Date(dateOfBirth);
  if (isNaN(dob.getTime())) return '';

  let years: number = now.getFullYear() - dob.getFullYear();
  let months: number = now.getMonth() - dob.getMonth();
  if (now.getDate() < dob.getDate()) months -= 1;
  if (months < 0) {
    years -= 1;
    months += 12;
  }
  if (years < 0) return '';

  if (years === 0) return `${months} ${labels.month}`;
  if (months === 0) return `${years} ${labels.year}`;
  return `${years} ${labels.year} ${labels.and} ${months} ${labels.month}`;
}

const MONTHS_PER_YEAR: number = 12;

export function formatAgeMonths(years: number, labels: AgeLabels): string {
  if (years < 0) return '';
  const months: number = Math.floor(years * MONTHS_PER_YEAR);
  return `${months} ${labels.month}`;
}
